<script lang='ts'>
	import { onMount } from "svelte"
	import { Events, Performers, Venues } from "~/lib/tn"
	import { addRecentlyViewed } from "~/stores/local"

export let type: 'event' | 'performer' | 'venue'
export let id: number | string

onMount(async () => {
  try {
  let payload = {
    type,
    id
  }

    
    if (type === 'event') {
      let res = await Events.get(id)
      payload = {
        ...payload,
        title: res.text?.name,
      }
    } else if (type === 'performer') {
      let res = await Performers.get(id)
      payload = {
        ...payload,
        title: res.text?.name,
      }
    } else if (type === 'venue') {
      let res = await Venues.get(id)
      payload = {
        ...payload,
        title: res.text?.name,
      }
    }
    
    addRecentlyViewed(payload)
  } catch (error) {
    console.error(error)
  }
})
</script>